module.exports = __webpack_public_path__ + "images/hot-tipper-cbd20d74f0492f8b75cb9e248aac71d0.png";